/**
 * Single source of truth for company identity, contact and shipping terms.
 * These values must match Google Merchant Center / KvK registration exactly.
 */
export const COMPANY = {
  name: "Elvion Group Nederland",
  legalName: "Elvion Group Nederland",
  address: "Betsy van Goorstraat 15",
  postal: "6702DC Wageningen",
  city: "Wageningen",
  country: "Nederland",
  kvk: "98117475",
  btw: "NL868363753B01",
  email: "info@elvion-group.nl",
  phone: "085 080 66 95",
  phoneHref: "+31850806695",
  website: "https://elvion-group.nl",
} as const;

/** Openingstijden zoals getoond op contact- en klantenservicepagina's. */
export const OPENING_HOURS = [
  { days: "Maandag t/m vrijdag", hours: "08:00 – 17:00" },
  { days: "Zaterdag", hours: "Op afspraak" },
  { days: "Zondag", hours: "Gesloten" },
] as const;

/**
 * Verzendtarieven — identiek in checkout, op productpagina's,
 * in het verzendbeleid en in de Google Merchant-feed.
 */
export const SHIPPING = {
  standardInclCents: 695,
  belgiumInclCents: 995,
  freeThresholdInclCents: 15000,
  carrier: "PostNL / DHL",
  deliveryNl: "1–2 werkdagen",
  deliveryBe: "2–3 werkdagen",
  cutoff: "16:00 uur op werkdagen",
} as const;

/** Consumentenrechten zoals vermeld in het retourbeleid. */
export const RETURNS = {
  withdrawalDays: 14,
  refundDays: 14,
  warrantyYears: 2,
} as const;
